import { deleteCombo,patchCombo,getComboById} from "../../services/ArticulosCombosServices"
import { ArticulosCombosContext } from "./ArticulosCombosContext"

export const ArticulosCombosState = ({ children }) => { 
  
    const deleteArticuloComboData = async (id) => {
        const res = await deleteCombo(id)
        return res
    }
     
    
    const patchArticuloComboData = async (id,body) => {
        const res = await patchCombo(id,body)
        return res
    }

        const getArticuloComboByIdData = async (id) => {
            let res = await getComboById(id)
            
            return res
        }

    return <ArticulosCombosContext.Provider value={{
        deleteArticuloComboData,
        patchArticuloComboData,
        getArticuloComboByIdData
    }} >
        {children}
    </ArticulosCombosContext.Provider>
}